import gql from 'graphql-tag';

export const MUTATION_BULK_OPERATION_FLOOR_PLANS = gql`
  mutation CMS_bulkOperateFloorPlans($input: BulkOperateFloorPlansInput!) {
    bulkOperateFloorPlans(input: $input) {
      floorPlans {
        id
        floorIndex
        block
      }
    }
  }
`;
